import { motion } from "framer-motion";
import { Chapter, Reveal } from "./Reveal";
import { ABOUT_PARAGRAPHS } from "../../data/portfolio";

const PORTRAIT = "/images/monica-portrait.webp";
const GOLFER = "/images/monica-golf.webp";

export const About = () => {
  return (
    <section
      id="about"
      className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-36"
      data-testid="about-section"
    >
      <Chapter num="01" label="Origin" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        {/* left: sticky heading */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <h2 className="font-display text-4xl md:text-6xl font-semibold tracking-tight leading-[0.95]">
                Discipline of an{" "}
                <span className="text-[#5E7E9B]">athlete.</span>
                <br />
                Instinct of a{" "}
                <span className="text-[#8AA189]">storyteller.</span>
              </h2>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-10 flex gap-4">
                <div className="relative overflow-hidden rounded-lg border border-[#1F2D3D]/10 w-1/2 aspect-[3/4] group">
                  <img
                    src={PORTRAIT}
                    alt="Monica Wu portrait"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    data-testid="about-portrait"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/50 to-transparent" />
                  <span className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-widest text-white/90">
                    The Professional
                  </span>
                </div>
                <div className="relative overflow-hidden rounded-lg border border-[#1F2D3D]/10 w-1/2 aspect-[3/4] mt-10 group">
                  <img
                    src={GOLFER}
                    alt="Monica Wu — BU Golf"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    data-testid="about-golfer"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/50 to-transparent" />
                  <span className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-widest text-white/90">
                    The Athlete
                  </span>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        {/* right: narrative */}
        <div className="lg:col-span-7 lg:pt-4">
          <div className="space-y-8">
            {ABOUT_PARAGRAPHS.map((p, i) => (
              <Reveal key={i} delay={i * 0.1}>
                <p
                  className={`leading-relaxed ${
                    i === 0
                      ? "text-2xl md:text-3xl text-[#1F2D3D] font-light tracking-tight"
                      : "text-lg text-[#5B6472]"
                  }`}
                  data-testid={`about-paragraph-${i}`}
                >
                  {p}
                </p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2}>
            <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 gap-px bg-[#1F2D3D]/[0.06] border border-[#1F2D3D]/10 rounded-lg overflow-hidden">
              {[
                ["Major", "Public Relations"],
                ["School", "Boston University"],
                ["Sport", "Division I Golf"],
                ["Languages", "EN · 中文"],
                ["Focus", "Marketing & Comms"],
                ["Status", "Seeking 2027 Internship"],
              ].map(([k, v]) => (
                <div key={k} className="bg-white shadow-[0_10px_40px_-20px_rgba(31,45,61,0.18)] p-5">
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#9AA3AF]">
                    {k}
                  </div>
                  <div className="mt-2 text-[#1F2D3D] font-medium">{v}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
